import vscode from "./vscode.svg";
import linux from "./linux.svg";
import windows from "./windows.svg";
import git from "./git.svg";
import github from "./github.svg";
import figma from "./figma.svg";

const stacks = [vscode, linux, windows, git, github, figma];

export default stacks;
